import { EIntegrationType } from "../types/AgencyIntegration";

export const E_AGENCY_INTEGRATION = {
  MAIN: "/agency-integrations",
  GOOGLE_CALLBACK: "user-integration/google/callback",
  CONNECTED: "/user-integration/connected",
  DISCONNECTED: "/user-integration/disconnected",
  SYNC_ALL_LEADS: "/contact-sale-submission/sync-all-leads",
  GET_BY_TYPE: (type: EIntegrationType) => `/user-integration/type/${type}`,
  SHEET_CONFIG: "/user-integration/sheet-config",
};
